import React, { useState } from 'react';
import { NodeType } from '../models';
import styles from './NodeDetails.module.scss';

interface Props {
  node: NodeType;
  onClose: () => void;
  onSave: (nodeId: string, context: string, intentCriteria: string) => void;
}

const GeneralNodeDetails: React.FC<Props> = ({ node, onClose, onSave }) => {
  const data = node.context ? JSON.parse(node.context) : {};
  const [info, setInfo] = useState(data.info || '');
  const [intentCriteria, setIntentCriteria] = useState(
    node.intentCriteria ||
      'общие запросы пользователей, которые не подходят под другие категории'
  );

  const handleSave = () => {
    const json = JSON.stringify({ info });
    onSave(node.id, json, intentCriteria);
    onClose();
  };

  return (
    <div className={styles.nodeDetails}>
      <h2 className={styles.nodeDetailsTitle}>GENERAL</h2>
      <div className={styles.nodeDetailsField}>
        <label className={styles.nodeDetailsLabel}>Intent Criteria</label>
        <textarea
          className={styles.nodeDetailsInput}
          value={intentCriteria}
          onChange={e => setIntentCriteria(e.target.value)}
          rows={3}
          placeholder="Критерии для определения intent'а"
        />
      </div>
      <div className={styles.nodeDetailsField}>
        <label className={styles.nodeDetailsLabel}>Info</label>
        <textarea
          className={styles.nodeDetailsInput}
          value={info}
          onChange={e => setInfo(e.target.value)}
          rows={3}
          placeholder="Дополнительная информация для обработки общих запросов"
        />
      </div>
      <div className={styles.nodeDetailsInfo}>
        <strong>Примечание:</strong> Этот блок является базовым и не может быть
        удален или добавлен.
      </div>
      <div className={styles.nodeDetailsButtons}>
        <button className={styles.cancelButton} onClick={onClose}>
          Cancel
        </button>
        <button className={styles.saveButton} onClick={handleSave}>
          Save
        </button>
      </div>
    </div>
  );
};

export default GeneralNodeDetails;
